import { FC } from 'react';
import { WbCronExpressionInput } from '@agilelab/plugin-wb-platform';
import { Controller, UseFormReturn } from 'react-hook-form';

type Props = UseFormReturn<any> & {
  value: string | undefined;
};

export const CronExpressionInput: FC<Props> = props => {
  return (
    <Controller
      control={props.control}
      name="cronExpression"
      render={({ field }) => (
        <WbCronExpressionInput
          value={field.value}
          onChange={field.onChange}
          title="Cron Expression"
        />
      )}
    />
  );
};
